// Single source of truth for the application's theme colors ("Mint Paper").
// Change a value here and it propagates everywhere: Ant Design components
// (via the ConfigProvider theme in main.jsx) and every page/component
// (via the CSS custom properties injected into :root by applyThemeCssVariables,
// which every stylesheet and inline style references as var(--wl-*)).

export const THEME_COLORS = {
  primary:        '#0F766E', // primary buttons, links, active/selected states
  primaryLight:   '#14A192', // gradient tops / hover accents on primary elements
  primaryRgb:     '15,118,110',
  primaryPale:    '#DCEBE6', // sidebar background, pale fills, subtle borders
  canvas:         '#F8FBFA', // app canvas / page background
  cardBg:         '#FFFFFF',
  text:           '#2D2D2D',
  textMuted:      '#45635E', // secondary / muted text
  success:        '#4DB847',
  successDark:    '#337A2F',
};

// CSS custom property names used throughout styles/index.css and inline styles.
export const CSS_VARS = {
  '--wl-primary':        THEME_COLORS.primary,
  '--wl-primary-light':  THEME_COLORS.primaryLight,
  '--wl-primary-rgb':    THEME_COLORS.primaryRgb,
  '--wl-primary-pale':   THEME_COLORS.primaryPale,
  '--wl-primary-gradient': `linear-gradient(181deg, ${THEME_COLORS.primaryLight} 0%, ${THEME_COLORS.primary} 100%)`,
  '--wl-sider-bg':       THEME_COLORS.primaryPale,
  '--wl-bg':             THEME_COLORS.canvas,
  '--wl-card-bg':        THEME_COLORS.cardBg,
  '--wl-text':           THEME_COLORS.text,
  '--wl-text-muted':     THEME_COLORS.textMuted,
  '--wl-border':         THEME_COLORS.primaryPale,
  '--wl-green':          THEME_COLORS.success,
  '--wl-green-dark':     THEME_COLORS.successDark,
};

// Applies the palette above as CSS custom properties on :root, overriding the
// fallback values declared in styles/index.css. Called once at app startup.
export function applyThemeCssVariables() {
  const root = document.documentElement;
  Object.entries(CSS_VARS).forEach(([name, value]) => root.style.setProperty(name, value));
}
